<div class="tCol clickCol desktop" id="RowSelect4_{{ item.id }}">
    <div *ngIf="!item.roleItem" [ngClass]="{ tYes: item.active, tNo: !item.active }" class="inviteStatus"></div>
</div>
